import { render, staticRenderFns } from "./MediaCollectionSelect.vue?vue&type=template&id=5d145450&"
import script from "./MediaCollectionSelect.vue?vue&type=script&lang=js&"
export * from "./MediaCollectionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports